// Next Diamonds — "clear" button inside the search field (header overlay and
// the search results page). Shows only while the field has text; one tap
// empties it and puts the cursor back in the field.
(function () {
  'use strict';
  if (window.__ndSearchClearBound) return;
  window.__ndSearchClearBound = true;

  function sync(input) {
    var box = input.closest('.main-search__input-container');
    var btn = box && box.querySelector('.main-search__clear');
    if (btn) btn.hidden = input.value.length === 0;
  }

  function isSearchInput(target) {
    return !!(target && target.matches && target.matches('.main-search__input'));
  }

  ['input', 'keyup', 'change'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (isSearchInput(e.target)) sync(e.target);
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.main-search__clear') : null;
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('.main-search__input-container');
    var input = box && box.querySelector('.main-search__input');
    if (!input) return;
    input.value = '';
    // The theme's live results and suggestions listen for keyup / change, so
    // these make them drop the old results and bring the quick links back.
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    sync(input);
    input.focus();
  });

  function init() {
    document.querySelectorAll('.main-search__input').forEach(sync);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
